// extracted by mini-css-extract-plugin
export default {"terms_footer":"TermsFooter_terms_footer__zR7Z0"};